import { Button, Select } from '@anyemp/ui-kit'
import { SortAsc, SortDesc } from 'lucide-react'
import { getNextSortOrder } from '../../utils/talentListInteractions'

const CompactCardSort = ({ options, sortBy, sortOrder, onSortByChange, onSortOrderChange }) => {
  const normalizedOrder = sortOrder === 'DESC' ? 'DESC' : 'ASC'
  const orderLabel = normalizedOrder === 'DESC' ? 'Descending' : 'Ascending'
  const nextOrder = getNextSortOrder(normalizedOrder)
  const nextOrderLabel = nextOrder === 'DESC' ? 'Descending' : 'Ascending'
  const OrderIcon = normalizedOrder === 'DESC' ? SortDesc : SortAsc

  return (
    <div className="grid min-w-0 flex-1 grid-cols-[minmax(0,1fr)_auto] items-end gap-2" role="group" aria-label="Card sorting controls">
      <Select
        label="Sort by"
        options={options}
        value={sortBy}
        onChange={(value) => onSortByChange(value || '')}
        size="small"
        fullWidth
      />
      <div className="flex min-w-0 flex-col gap-1">
        <span className="text-sm font-medium text-light-text-secondary dark:text-dark-text-secondary">Order</span>
        <Button
          type="button"
          variant="outlined"
          color="neutral"
          size="small"
          onClick={() => onSortOrderChange(nextOrder)}
          aria-label={`Sort order: ${orderLabel}. Change to ${nextOrderLabel}`}
          title={`Change sort order to ${nextOrderLabel}`}
          sx="min-h-11 min-w-11 px-2"
        >
          <span className="inline-flex items-center justify-center">
            <OrderIcon className="h-4 w-4" aria-hidden="true" />
          </span>
        </Button>
      </div>
    </div>
  )
}

export default CompactCardSort
